import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import VisitOurCampus from "./sections/VisitOurCampus";
import ReachOutToTheKitchen from "./sections/ReachOutToTheKitchen";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <VisitOurCampus />
      <ReachOutToTheKitchen />
      <Footer />
    </div>;
}